module.exports = __webpack_public_path__ + "static/media/lock-orange-48x48.cc1dd485.svg";